/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifacts_Download_Selected_MdInputs */



/**
* | output |
* | --- |
* | "Markdown (ZIP)" |
*
* @param {Artifacts_Download_Selected_MdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifacts_download_selected_md = /** @type {((inputs?: Artifacts_Download_Selected_MdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifacts_Download_Selected_MdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Markdown (ZIP)")
	return /** @type {LocalizedString} */ ("Markdown (ZIP)")
});